// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to change the system date of a selected branch. Posting date will be the first following working day.
  </span>
</div>

<div class="alert alert--danger" ng-if="!\$ctrl.newSystemDateValid">
  <span>
    Following branches' system date can't be updated to {{ \$ctrl.newSystemDate }} due to the current system date or working day not started:
    <ul>
      <li ng-repeat="branch in \$ctrl.getInvalidSelectedBranches() | orderBy:'name'">
        {{ branch.code }}
      </li>
    </ul>
  </span>
</div>

<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branches</td>
      <td>
        <branch-filter
          ng-if="\$ctrl.availableBranches"
          ng-model="\$ctrl.selectedBranchIds"
          options="\$ctrl.availableBranches"
          ng-change="\$ctrl.onFormChange()"
          ng-required="true"
        >
        </branch-filter>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>System date</td>
      <td>
        <date ng-model="\$ctrl.newSystemDate"
              ng-change="\$ctrl.onFormChange()"
              ng-class="{ 'nx-invalid': !\$ctrl.newSystemDateValid }"
              required>
        </date>
      </td>
      <td></td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="button"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid || !\$ctrl.newSystemDateValid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-branch-system-date/update-branch-system-date.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;